import jQuery from 'jquery';

;(function($){

const localNav = $('.c-localNav'),
      localNavContainer = localNav.find('.c-localNav-container'),
      localNavHeight = localNavContainer.innerHeight(),
      offset = localNav.offset(),
      header = $('header');

if(!localNav.length) return;

function localNavFixed(){
  if($(window).scrollTop() >= offset.top + localNavHeight - header.innerHeight()){
    localNavContainer.addClass('is-fixed');
  } else {
    localNavContainer.removeClass('is-fixed');
  }
}
$(window).on('load scroll', localNavFixed);
localNav.height(localNavHeight);
localNavFixed();


}(jQuery));